import React from "react";
import "./loader.css"

const Loader = ({showLoading = true}) => {
    return (
        <div hidden={showLoading} className="loader">
            <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>)
}

export default Loader;
